export default "__VITE_ASSET__DVwAN14T__"